"use strict";

module.exports = function (column) {
  return !this.opts.descOrderColumns.includes(column);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/initial-order-ascending.js
// module id = 909
// module chunks = 0